const TRACKER_DATA_ATTRIBUTES = {
    top_cat: 'top_cat',
    top_collection: 'top_collection',
    top_brand: 'top_brand',
    top_deal: 'top_deal',
    top_inspiration: 'top_inspiration',
    top_activity: 'top_activity',
    top_main: 'top_main',
    top_banner: 'top_banner',
    side_cat: 'side_cat',
    side_sub: 'side_sub',
    side_activity: 'side_activity',
    side_brand: 'side_brand',
    listing_banner: 'listing_banner',
    breadcrumb: 'breadcrumb',
    front_banner: 'front_banner',
    front_mid: 'front_mid',
    front_brand: 'front_brand',
    pdp_brandname: 'pdp_brandname',
    pdp_tag_discover: 'pdp_tag_discover',
    pdp_tag_series: 'pdp_tag_series',
    az_brandname: 'a-z_brandname',
    fav_brandname: 'fav_brandname',
    collabs_banner: 'collabs_banner',
    product_card_banner: 'product_card_banner'
};

export default TRACKER_DATA_ATTRIBUTES;
